import * as React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AbaToastContainer } from '@ReactComponents/AbaToastContainer';
import { ModalRoot } from '@ReactComponents/Shared/ModalRoot';
import { SignUpPage } from '@ReactComponents/SignUp/SignUpPage';
import { SignUpWorkflow } from '@ReactComponents/SignUp/SignUpWorkflow';

import { store } from '@ReactStore/store';

import { AbacusEmbarkProvider } from 'shared/AbacusEmbarkProvider';

const queryClient = new QueryClient();
__webpack_public_path__ = window.webpack_public_path;
ReactDOM.render(
  <AbacusEmbarkProvider>
    <BrowserRouter>
      <Provider store={store}>
        <IntlProvider locale="en-US">
          <QueryClientProvider client={queryClient}>
            <Routes>
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/signup/onboarding" element={<SignUpWorkflow />} />
              <Route path="/signup/onboarding/cards_completed" element={<SignUpWorkflow startStage={'PAYMENT_SUMMARY'} />} />
              <Route
                path="/signup/additional_company"
                element={<SignUpWorkflow startStage={'COMPANY_INFORMATION'} isAdditionalCompany />}
              />
            </Routes>
            <ModalRoot />
          </QueryClientProvider>
        </IntlProvider>
        <AbaToastContainer />
      </Provider>
    </BrowserRouter>
  </AbacusEmbarkProvider>,
  document.querySelector('#app')
);
